module.exports = __webpack_public_path__ + "img/finished-stage.53acab41.png";